
import { mountThemeFeature } from './editor-lifecycle.js';

mountThemeFeature(lifecycle => {
const { IntersectionObserver, ResizeObserver, setTimeout, setInterval, requestAnimationFrame } = lifecycle;
/* ============================================================
   The scroll cue: a fine plumb line of indigo at the foot of the
   window, easing away the moment the reader moves.
   ============================================================ */
const cues = [...document.querySelectorAll('[data-scroll-cue]')];
if (cues.length) {
  let done = false;
  const check = () => {
    if (!done && scrollY > 60) { done = true; cues.forEach(c => c.classList.add('is-done')); }
  };
  lifecycle.listen(window, 'scroll', check, { passive: true });
  check();
  cues.forEach(cue => lifecycle.listen(cue, 'click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollBy({ top: window.innerHeight * 0.9, behavior: reduce ? 'auto' : 'smooth' });
  }));
}

});
